/**
 * MCP管理页面
 * 管理员专用 - 管理MCP服务器和工具
 */

import { LayoutWithSidebar } from "@/components/LayoutWithSidebar";
import { McpServerList } from "@/components/McpServerList";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";

export function MCPManagementPage() {
  return (
    <LayoutWithSidebar title="MCP服务器管理">
      <div className="flex flex-1 flex-col p-4">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 w-full">
            
            <Alert>
              <InfoIcon className="h-4 w-4" />
              <AlertDescription>
                <div className="space-y-2">
                  <p className="font-medium">使用说明：</p>
                  <ol className="list-decimal list-inside space-y-1 text-sm">
                    <li>在"使用中的工具"列表中，点击"发布"按钮将工具发布到市场</li>
                    <li>系统会自动同步工具到数据库并发布</li>
                    <li>发布后的工具可以被其他用户在工具市场中看到并订阅</li>
                    <li>你可以在"已发布工具"页面查看和管理所有已发布的工具</li>
                  </ol>
                </div>
              </AlertDescription>
            </Alert>

            <div className="mt-6">
              <McpServerList />
            </div>
          </div>
        </div>
      </div>
    </LayoutWithSidebar>
  );
}

export default MCPManagementPage;

